export default __webpack_public_path__ + "static/media/zanetti.3606b0bd.png";